import {
    baseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const authManualapi = createApi({
    reducerPath: "authManualapi",
    baseQuery: baseQuery,
    endpoints: (builder) => ({

        manualRegister: builder.mutation({
            query: (requestData) => ({
                url: `/auth/s-auth/sign-up`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        manualSendOtp: builder.query({
            query: (requestData) => ({
                url: `/auth/s-auth/send-otp`,
                method: 'POST',
                body: transformRequest(requestData),

            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        manualVerifyOtp: builder.mutation({
            query: (requestData) => ({
                url: `/auth/s-auth/verify-otp`,
                method: 'POST',
                body: transformRequest(requestData),

            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        manualCreatePassword: builder.mutation({
            query: (requestData) => ({
                url: `/auth/s-auth/set-password`,
                method: 'POST',
                body: transformRequest(requestData),

            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })
    }),
});

export const {
    useManualRegisterMutation, useLazyManualSendOtpQuery, useManualVerifyOtpMutation,
    useManualCreatePasswordMutation } = authManualapi;

export default authManualapi;
